import LegalLayout from "@components/templates/legal-layout";
import sectionsRef from "@models/interactions/sections-ref";

export default function EndUserLegal() {
  const { model, operations } = sectionsRef(10);

  return (
    <LegalLayout>
      <main className="w-full flex flex-col text-white px-4 max-w-[900px] mt-[60px] pb-5">
        <h2 className="text-4xl text-center font-semibold">End-User License Agreement</h2>
        <span className="text-left mt-4 leading-[23px]">This End-User License Agreement ("EULA") is a binding contract between you (“you”)
          and Memo’d Technologies, LLC (“Memo’d,” “we,” “us” or “our”) governing your use of
          any mobile applications that Memo’d makes available for download or use
          (individually and collectively, the “App”), the Memo’d website located at 
          <a href="https://www.memod.com" className="text-blue-700 hover:underline"> www.memod.com</a>, and any other online properties owned or controlled by or on behalf of Memo’d
          (collectively with the App, the “Services”). BY ACCESSING, DOWNLOADING, INSTALLING, OR OTHERWISE USING THE SERVICES,
          YOU AGREE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS EULA. IF YOU DO NOT AGREE TO THE TERMS OF THIS EULA,
          THEN YOU MUST NOT USE THESE SERVICES.
        </span>

        <div className="w-full flex flex-col text-white text-xl mt-5">
          <span>
            1.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[0]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              License
            </a>
          </span>
          <span>
            2.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[1]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Restrictions
            </a>
          </span>
          <span>
            3.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[2]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Modifications to Services
            </a>
          </span>
          <span>
            4.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[3]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Additional Terms
            </a>
          </span>
          <span>
            5.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[4]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Term and Termination
            </a>
          </span>
          <span>
            6.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[5]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Privacy
            </a>
          </span>
          <span>
            7.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[6]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Warranty Clause
            </a>
          </span>
          <span>
            8.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[7]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Severability
            </a>
          </span>
          <span>
            9.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[8]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Amendments to this Agreement
            </a>
          </span>
          <span>
            10.
            <a
              onClick={() => {
                operations.scrollToRef(model.refs[9]);
              }}
              className="ml-1 cursor-pointer text-memod-green-base underline"
            >
              Contact Information
            </a>
          </span>
        </div>

        <article className="flex w-full flex-col justify-start gap-[18px] lg:w-[916px] text-white mt-4">
          <section ref={model.refs[0]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">License</strong>
              <p>Memo’d grants you a revocable, non-exclusive, non-transferable, limited license
              to download, install and use the Services solely for your personal, non-commercial 
              purposes strictly in accordance with the terms of this EULA and other Memo’d Policies
              (as defined below) .
              </p>
            </span>
          </section>
          <section ref={model.refs[1]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Restrictions</strong>
              <p>You agree not to, and you will not permit others to license, sell, rent, lease, assign,
                distribute, transmit, host, outsource, disclose, or otherwise commercially exploit
                the Services or make the Services available to any third party.
              </p>
            </span>
          </section>
          <section ref={model.refs[2]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Modifications to Services</strong>
              <p>Memo’d reserves the right to modify, suspend, or discontinue, temporarily or permanently,
                the Services or any service to which it connects, with or without notice and without
                liability, to you.
              </p>
            </span>
          </section>
          <section ref={model.refs[3]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Additional Terms</strong>
              <p>
                Additional terms may be applicable to your use of the Services,
                such as Memo’d’s terms of service (available at <a href="https://memod.com/legal/terms-of-service" className="hover:underline text-memod-green-base">https://memod.com/legal/terms-of-service</a>);
                Memo’d’s privacy policy (available at <a href="https://memod.com/legal/privacy-policy" className="hover:underline text-memod-green-base">https://memod.com/legal/privacy-policy</a>);
                and Memo’d Creator Program terms of use (available at <a href="https://memod.com/founders/program-terms-of-service" className="hover:underline text-memod-green-base">https://memod.com/founders/program-terms-of-service</a>)
                (collectively, the “Policies”).
              </p>
            </span>
          </section>
          <section ref={model.refs[4]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Term and Termination</strong> 
              <p>
                This EULA shall remain in effect until terminated by you or Memo’d. Memo’d may,
                 in its sole discretion, at any time and for any or no reason, suspend or terminate
                  this EULA with or without prior notice.
              </p>

              <p>
                This EULA will terminate immediately, without prior notice from Memo’d, in the event
                 that you fail to comply with any provision of this EULA. You may also terminate this
                  Agreement by deleting the Services and all copies thereof from your mobile device or
                   from your desktop.
              </p>

              <p>
              Upon termination of this EULA, you shall cease all use of the Services and delete all
               copies of the Services from your mobile device or from your desktop.
              </p>

            </span>
          </section>
          <section ref={model.refs[5]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Privacy</strong>
              <p>Your use of the Services is in accordance with and governed by Memo’d’s Privacy Policy,
                available at: <a href="https://memod.com/legal/privacy-policy" className="hover:underline text-memod-green-base">https://memod.com/legal/privacy-policy</a>.
              </p>
            </span>
          </section>
          <section ref={model.refs[6]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Warranty Clause</strong>
              <p>Any warranties as and is described will be subjected to the Warranty Disclaimers section of Memo’d’s
                Terms of Service, available at: <a href="https://memod.com/legal/terms-of-service" className="hover:underline text-memod-green-base">https://memod.com/legal/terms-of-service</a>.
              </p>
            </span>
          </section>
          <section ref={model.refs[7]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Severability</strong>
              <p>If any provision of this Agreement is held to be unenforceable or invalid,
                such provision will be changed and interpreted to accomplish the objectives
                of such provision to the greatest extent possible under applicable law and
                the remaining provisions will continue in full force and effect.
              </p>
            </span>
          </section>
          <section ref={model.refs[8]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Amendments to this Agreement</strong>

              <p>Memo’d reserves the right, at its sole discretion,
                to modify or replace this Agreement at any time.
              </p>
            </span>
          </section>
          <section ref={model.refs[9]} className="flex flex-col gap-5 ">
            <span className="flex flex-col gap-[18px]">
              <strong className="text-xl">Contact Information</strong>

              <p >If you have any questions about this EULA,
                please contact us at: <a href="mailto:support@memod.com" className="hover:underline text-memod-green-base">support@memod.com</a>.
              </p>

              <p>Last updated: November 2021</p>
            </span>
          </section>
        </article>

      </main>
    </LegalLayout>
  );
}
